<template>
  <div class="bg-light">
    <bottom-bar/>
    <div class="content">
      <div class="container-fluid">
        <modal-menu :menus="menus" :selected="menu" @changeMenu="selecionarAba" class="mb-3 mt-md-2" v-show="empresa.fidelidade || cupons.length || promocoes.length"/>
        <div v-if="menu === 1">
          <produtos-categoria :produtos="promocoes" @openProduto="openProduto"/>
        </div>
        <div v-if="menu === 2">
          <fidelidade/>
        </div>
        <div v-if="menu === 3">
          <cupom componente="true" readonly="true" @cuponsDisponiveis="setCupons"/>
        </div>
      </div>
    </div>

    <produto ref="produto" :empresaAberta="empresa.empresaAberta" :isComponente="true" @modalImage="openModalImg"/>
    <modal-image :opened="modalImage" :url="modalImage ? modalImage : base_cdn + '/static/imgs/default.png'" @closeModal="modalImage = false"/>
  </div>
</template>

<script>
  import BottomBar from "../components/BottomBar";
  import Cupom from "../components/Cupom";
  import ModalMenu from "../components/ModalMenu";
  import Icon from "../components/Icon";
  import Fidelidade from "./Fidelidade";
  import ProdutosCategoria from "../components/ProdutosCategoria";
  import Produto from "../components/Produto";
  import ModalImage from "../components/ModalImage";

  export default {
    name: 'Promocoes',
    components: {ModalImage, Produto, ProdutosCategoria, Fidelidade, ModalMenu, Cupom, BottomBar, Icon },
    data() {
      return {
        token: localStorage.getItem('token'),
        cupons: [],
        modalImage: false,
        menu: 1,
        menus: [
          { nome: 'Produtos', active: false },
          { nome: 'Clube', active: true },
          { nome: 'Cupons', active: true }
        ],
      }
    },

    methods: {
      selecionarAba(menu) {
        this.menu = menu;
        const aba = ['produtos', 'clube', 'cupons'][menu - 1];
        if (this.$route.query.aba !== aba) {
          this.$router.replace({query: {...this.$route.query, aba}});
        }
      },

      openProduto(id, id_categoria) {
        this.$refs.produto.openProduto({ id, id_categoria });
      },

      openModalImg(img) {
        if (img) {
          this.modalImage = img;
        }
      },

      setCupons(cupons) {
        this.cupons = cupons;
      }
    },

    mounted() {
      this.$emit('buscarCupons');
      this.menus[0].active = !!this.promocoes.length;
      this.menus[1].active = !!this.empresa.fidelidade;

      const primeiraAbaAtiva = this.menus.findIndex(menu => menu.active);
      const abaSolicitada = ['produtos', 'clube', 'cupons'].indexOf(this.$route.query.aba);
      this.menu = abaSolicitada >= 0 && this.menus[abaSolicitada].active
        ? abaSolicitada + 1
        : (primeiraAbaAtiva >= 0 ? primeiraAbaAtiva + 1 : 3);
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      promocoes() {
        return this.$store.state.cardapio.promocoes || [];
      }
    }
  }
</script>

<style scoped>
</style>
